﻿import { checkbox as cb } from 'common/barrels/dom';
import { bind, canWrite, Binding } from 'common/dom/binding';
import { Observable } from 'common/barrels/rx';

export function checkbox(value: Binding<boolean>) {
    const $checkbox = cb();

    if (!canWrite(value))
        $checkbox.attr('disabled', 'disabled');

    const subscriptions = bind<boolean>(value, x => $checkbox.prop('checked', x), () => Observable.fromEvent<any>($checkbox, 'click').map(() => <boolean>$checkbox.prop('checked')));

    return $checkbox.owns(subscriptions);
}